var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.dnt
    ? _c("div", [
        _c("div", { staticClass: "d-flex" }, [
          _c("div", { staticClass: "field" }, [_vm._v("Tipo Documento:")]),
          _c("div", { staticClass: "values" }, [_vm._v(_vm._s(_vm.getTitle()))])
        ]),
        _c("div", { staticClass: "d-flex" }, [
          _c("div", { staticClass: "field" }, [_vm._v("Folio:")]),
          _c("div", { staticClass: "values" }, [_vm._v(_vm._s(_vm.dnt.numero))])
        ]),
        _c("div", { staticClass: "d-flex" }, [
          _c("div", { staticClass: "field" }, [_vm._v("Hora y Fecha:")]),
          _c("div", { staticClass: "values" }, [
            _vm._v(_vm._s(_vm.dnt.fechaCreacion))
          ])
        ]),
        _vm.dnt.tipo === _vm.documents.project
          ? _c("div", [
              _c("div", { staticClass: "field" }, [_vm._v("Estado")]),
              _c(
                "div",
                { staticClass: "values" },
                [
                  _vm.dnt.estadoCodigoEstadoSistema ===
                  _vm.systemStatusCode.created
                    ? _c("span", [_vm._v("Creado")])
                    : _vm._e(),
                  _vm.dnt.estadoCodigoEstadoSistema ===
                  _vm.systemStatusCode.rejected
                    ? _c("span", [_vm._v(" Rechazado")])
                    : _vm._e(),
                  _vm.dnt.estadoCodigoEstadoSistema ===
                  _vm.systemStatusCode.reparos
                    ? _c("span", [_vm._v("Reparos")])
                    : _vm._e(),
                  _vm.dnt.estadoCodigoEstadoSistema ===
                  _vm.systemStatusCode.accepted
                    ? _c("span", [_vm._v("Aceptado")])
                    : _vm._e(),
                  _vm.dnt.estadoCodigoEstadoSistema ===
                  _vm.systemStatusCode.pendingApproval
                    ? _c("span", [_vm._v(" Pendiente Aprobacion ")])
                    : _vm._e(),
                  _vm.dnt.estadoCodigoEstadoSistema ===
                  _vm.systemStatusCode.closed
                    ? _c("span", [_vm._v("Cerrado")])
                    : _c("spans", [_vm._v("Desconocido")])
                ],
                1
              )
            ])
          : _vm._e(),
        _vm.showDeliveryDate
          ? _c("div", { staticClass: "d-flex" }, [
              _c("div", { staticClass: "field" }, [
                _vm._v("Fecha de entrega:")
              ]),
              _c("div", { staticClass: "values" }, [
                _vm._v(_vm._s(_vm.dnt.fechaEntrega))
              ])
            ])
          : _vm._e(),
        _vm.showState
          ? _c("div", { staticClass: "d-flex" }, [
              _c("div", { staticClass: "field" }, [_vm._v("Estado:")]),
              _c("div", { staticClass: "values" }, [
                _vm._v(
                  _vm._s(
                    _vm.dnt.estadoDescripcionEstadoSistema || _vm.dnt.estado
                  )
                )
              ])
            ])
          : _vm._e(),
        _c("div", { staticClass: "d-flex" }, [
          _c("div", { staticClass: "field" }, [_vm._v("Descripción:")]),
          _c("div", { staticClass: "values" }, [
            _vm._v(_vm._s(_vm.dnt.nombreDescriptivo))
          ])
        ]),
        _vm.dnt.tipo === _vm.documents.milestone
          ? _c("div", { staticClass: "d-flex" }, [
              _c("div", { staticClass: "field" }, [_vm._v("Porcentaje")]),
              _c("div", { staticClass: "values" }, [
                _vm._v(_vm._s(_vm.dnt.porcentaje) + " %")
              ])
            ])
          : _vm._e(),
        _vm.showEnterpriseRut
          ? _c("div", { staticClass: "d-flex" }, [
              _c("div", { staticClass: "field" }, [_vm._v("RUT Empresa:")]),
              _c("div", { staticClass: "values" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.formatNumber(_vm.dnt.receptorRut.split("-")[0])
                    ) +
                    " - " +
                    _vm._s(_vm.dnt.receptorRut.split("-")[1]) +
                    " "
                )
              ])
            ])
          : _vm._e(),
        _vm.showSender
          ? _c("div", { staticClass: "d-flex" }, [
              _c("div", { staticClass: "field" }, [_vm._v("Emisor:")]),
              _c("div", { staticClass: "values" }, [
                _vm._v(
                  " " +
                    _vm._s(_vm.dnt.emisorRazonSocial) +
                    " " +
                    _vm._s(_vm.formatNumber(_vm.dnt.emisorRut.split("-")[0])) +
                    " - " +
                    _vm._s(_vm.dnt.emisorRut.split("-")[1]) +
                    " "
                )
              ])
            ])
          : _vm._e(),
        _vm.dnt.tipo === _vm.documents.electronicMemorandum
          ? _c("div", { staticClass: "d-flex" }, [
              _c("div", { staticClass: "field" }, [_vm._v("Destino")]),
              _c("div", { staticClass: "values" }, [
                _vm._v(
                  " " +
                    _vm._s(_vm.info.dnt.receptorContactoNombre) +
                    " - " +
                    _vm._s(_vm.info.dnt.receptorContactoCargo) +
                    " "
                )
              ])
            ])
          : _vm._e(),
        _vm.showReceptor
          ? _c("div", { staticClass: "d-flex" }, [
              _c("div", { staticClass: "field" }, [_vm._v("Receptor:")]),
              _c("div", { staticClass: "values" }, [
                _vm._v(
                  " " +
                    _vm._s(_vm.dnt.receptorRazonSocial) +
                    " " +
                    _vm._s(
                      _vm.formatNumber(_vm.dnt.receptorRut.split("-")[0])
                    ) +
                    " - " +
                    _vm._s(_vm.dnt.receptorRut.split("-")[1])
                )
              ])
            ])
          : _vm._e(),
        _vm.showAmountType1 || _vm.showAmountType2 || _vm.showAmountType3
          ? _c("div", { staticClass: "d-flex" }, [
              _c("div", { staticClass: "field" }, [_vm._v("Monto:")]),
              _vm.showAmountType1
                ? _c("div", { staticClass: "values" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.formatNumber(_vm.dnt.totalPrecioTotalExento)
                        ) +
                        " " +
                        _vm._s(_vm.dnt.totalMonedaCodigo) +
                        " " +
                        _vm._s(_vm.dnt.totalMonedaDescripcion) +
                        " "
                    )
                  ])
                : _vm._e(),
              _vm.showAmountType2
                ? _c("div", { staticClass: "values" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm.formatNumber(_vm.dnt.totalPrecioTotalNeto)) +
                        " " +
                        _vm._s(_vm.dnt.totalMonedaCodigo || "CLP") +
                        " "
                    )
                  ])
                : _vm._e(),
              _vm.showAmountType3
                ? _c("div", { staticClass: "values" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm.formatNumber(_vm.dnt.totalPrecioTotalNeto)) +
                        " "
                    )
                  ])
                : _vm._e()
            ])
          : _vm._e()
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }